import { lazy } from "react";

import Suspense from "components/shared/Suspense";
import Container from "hardcover-ui/components/Container";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";
import Modal from "hardcover-ui/components/Modal";

import { SearchContextType } from "../../search/types";

const QuickSearchForm = lazy(() => import("./QuickSearchForm"));

type Props = {
  isOpen?: boolean;
  onClose: () => void;
  searchOptions?: SearchContextType;
};

export function QuickSearchModal({
  isOpen = false,
  onClose,
  searchOptions,
}: Props) {
  return (
    <Modal onClose={onClose} open={isOpen} position="top" modalTitle="Search">
      <Container>
        <Suspense fallback={<LoadingSpinner size="lg" variant="layout" />}>
          {isOpen && (
            <QuickSearchForm
              searchOptions={{
                ...searchOptions,
                ...{ onClose, isOpen },
              }}
            />
          )}
        </Suspense>
      </Container>
    </Modal>
  );
}
